import { FunctionComponent } from 'react';
import { Statistic as AntdStatistic, StatisticProps } from 'antd';

export const Statistic: FunctionComponent<StatisticProps> = (props) => {
  return <AntdStatistic className={'notranslate'} {...props} />;
};
